import  "./HomeContainer.css"


const HomeContainer = ({item}) => {
  return (
    <div className="homeContainer">
      <img src={item.img} alt="" className="cartImg" />
        <div className="homeTitle"><h3 className="homeDesc">{item.title}</h3></div>
    </div>
  )
}

export default HomeContainer